export const PARSE_CONFIG = {
    firstRelativePhone: 'contacts[0].phone',
    firstRelativeFIO: 'contacts[0].firstName',
    firstRelativeAccountedFor: 'contacts[0].relationType',

    secondRelativePhone: 'contacts[1].phone',
    secondRelativeFIO: 'contacts[1].firstName',
    secondRelativeAccountedFor: 'contacts[1].relationType'
};

export const GET_PROFILE_CONFIG = {
    firstRelativePhone: 'contacts.0.phone',
    firstRelativeFIO: 'contacts.0.firstName',
    firstRelativeAccountedFor: 'contacts.0.relationType',

    secondRelativePhone: 'contacts.1.phone',
    secondRelativeFIO: 'contacts.1.firstName',
    secondRelativeAccountedFor: 'contacts.1.relationType'
};


export const BLOCKS_CONFIG = [

    {
        name: 'firstRelativeType',
        fields: ['firstRelativeAccountedFor'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'firstRelativeInfo',
        fields: ['firstRelativeFIO', 'firstRelativePhone'],
        confirmed: false,
        filledCount: 0
    },

    {
        name: 'secondRelativeType',
        fields: ['secondRelativeAccountedFor'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'secondRelativeInfo',
        fields: ['secondRelativeFIO', 'secondRelativePhone'],
        confirmed: false,
        filledCount: 0
    },
];
